var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaqueDEau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flaque_d_eau",
    "data-name": "flaque d'eau",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.2 49.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3e80b7;}.cls-2{fill:#51b8e0;}.cls-3{fill:none;stroke:#a7e8fc;stroke-miterlimit:10;stroke-width:0.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flaque d&amp;apos;eau") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.9,2125.48c-14.16-2.5-44.12-16.63-25.32-16.89,36.08-.5,20.29-6.55,7-8.31-6.16-.82-28-2.37-12.5-9.89,7.85-3.81,22.75-10.63,40.63-8.72,24.09,2.58,8.29-6.6,34,1.82,11.24,3.68,23,2.07,34.34,3.58,40.55,5.41-14.32,4.61,35.22,15.44,26.92,5.89,3,21.6-25.61,23.35-11.31.7-24.57,4-36,.31-25.51-8.24-28.2-3.68-18.86-1.15C247.82,2128,208.41,2126.28,203.9,2125.48Z",
    transform: "translate(-165.8 -2078.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.31,2123.91c-14.16-2.5-44.12-16.62-25.32-16.89,36.08-.5,20.29-6.55,7-8.31-6.16-.82-28-2.37-12.5-9.89,7.85-3.81,22.75-10.63,40.63-8.71,24.09,2.58,8.29-6.61,34,1.81,11.24,3.68,23,2.07,34.35,3.59,40.54,5.4-14.33,4.6,35.22,15.43,26.91,5.89,3,21.6-25.62,23.36-11.31.69-24.57,4-36,.3-25.51-8.24-28.2-3.67-18.86-1.14C246.23,2126.44,206.82,2124.71,202.31,2123.91Z",
    transform: "translate(-165.8 -2078.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.66,2100.94c26.91,5.89,3,21.6-25.62,23.36-11.31.69-24.57,4-36,.3-25.51-8.24-28.2-3.67-18.86-1.14,11,3-28.4,1.25-32.91.45-14.16-2.5-44.12-16.62-25.32-16.89,36.08-.5,20.29-6.55,7-8.31-6.16-.82-28-2.37-12.5-9.89",
    transform: "translate(-165.8 -2078.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.59,2113.11c1.56,0,18.81,6.27,32.91,7.83s51.73-6.27,53.29-11-3.13-7.84-11-7.84",
    transform: "translate(-165.8 -2078.28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.75,2120.94h-7.84",
    transform: "translate(-165.8 -2078.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.43,2110.91s-1.26.2-3.54-1.93",
    transform: "translate(-165.8 -2078.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaqueDEau);
export default __webpack_public_path__ + "static/media/flaque_d_eau.95ab510912315b368605f2de051fb782.svg";
export { ForwardRef as ReactComponent };